__turbopack_context__.v({
  "buttonContainer": "VideoEmbed-module-scss-module__7poVlW__buttonContainer",
  "customImageAndPlayButton": "VideoEmbed-module-scss-module__7poVlW__customImageAndPlayButton",
  "image": "VideoEmbed-module-scss-module__7poVlW__image",
  "playButton": "VideoEmbed-module-scss-module__7poVlW__playButton",
  "root": "VideoEmbed-module-scss-module__7poVlW__root",
  "setButtonCentered": "VideoEmbed-module-scss-module__7poVlW__setButtonCentered",
  "video": "VideoEmbed-module-scss-module__7poVlW__video",
  "videoDescription": "VideoEmbed-module-scss-module__7poVlW__videoDescription",
});
